"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * RichWise_Website_API.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfUserRoleViewModel = instanceOfUserRoleViewModel;
exports.UserRoleViewModelFromJSON = UserRoleViewModelFromJSON;
exports.UserRoleViewModelFromJSONTyped = UserRoleViewModelFromJSONTyped;
exports.UserRoleViewModelToJSON = UserRoleViewModelToJSON;
exports.UserRoleViewModelToJSONTyped = UserRoleViewModelToJSONTyped;
/**
 * Check if a given object implements the UserRoleViewModel interface.
 */
function instanceOfUserRoleViewModel(value) {
    return true;
}
function UserRoleViewModelFromJSON(json) {
    return UserRoleViewModelFromJSONTyped(json, false);
}
function UserRoleViewModelFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'orderString': json['orderString'] == null ? undefined : json['orderString'],
        'currentPage': json['currentPage'] == null ? undefined : json['currentPage'],
        'pageSize': json['pageSize'] == null ? undefined : json['pageSize'],
        'urUNo': json['urUNo'] == null ? undefined : json['urUNo'],
    };
}
function UserRoleViewModelToJSON(json) {
    return UserRoleViewModelToJSONTyped(json, false);
}
function UserRoleViewModelToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'orderString': value['orderString'],
        'currentPage': value['currentPage'],
        'pageSize': value['pageSize'],
        'urUNo': value['urUNo'],
    };
}
